// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u5-0";
export var checkoutRateBadgeLink = "_u5-1";